<ng-template #toast>
  <div nz-flex nzAlign="center" nzJustify="space-between" nzGap="middle">
    <div>
      <div class="title">{{ i18n.app_update.title | translate }}</div>
      <div class="subtitle">{{ i18n.app_update.body | translate }}</div>
    </div>

    <button nz-button nzType="primary" nzSize="small" (click)="onReload()">
      {{ i18n.app_update.reload | translate }}
    </button>
  </div>
</ng-template>
